import { useEffect, useState } from 'react';
import { Section, SearchBar } from '@ui/library';
import { VideoCatalog, ContactCTA } from '@ui/sections';
import { videoGroups } from '@content/videos';
import { site } from '@content/site';
import { videosCopy, contactCtaCopy } from '@content/ui-strings';

const PAGE_SIZE = 9;

export function VideosRoute() {
  useEffect(() => {
    document.title = `Videos · ${site.seo.title.split(' · ')[0] ?? 'Alison Haire'}`;
  }, []);

  // Per-group current page (1-indexed). Defaults to 1 for any group.
  const [pages, setPages] = useState<Record<string, number>>({});
  const [query, setQuery] = useState('');

  const handlePageChange = (groupTitle: string, page: number) => {
    setPages((prev) => ({ ...prev, [groupTitle]: page }));
  };

  return (
    <>
      <Section
        id="videos"
        eyebrow={videosCopy.eyebrow}
        title={videosCopy.title}
        lead={videosCopy.lead}
      >
        <div className="video-catalog-controls">
          <SearchBar
            value={query}
            onChange={setQuery}
            placeholder={videosCopy.searchPlaceholder}
            ariaLabel={videosCopy.searchAriaLabel}
          />
        </div>
        <div style={{ marginTop: 24 }}>
          <VideoCatalog
            groups={videoGroups}
            pageSize={PAGE_SIZE}
            pages={pages}
            onPageChange={handlePageChange}
            filter={query}
            copy={videosCopy.catalog}
          />
        </div>
      </Section>
      <ContactCTA calendlyHref={site.links['calendly'] ?? '#'} copy={contactCtaCopy} />
    </>
  );
}
